import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdjuntoComponent } from './adjunto.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout'; 

const routes = [
  {
      path     : 'proveedores/mis-pagos/adjunto',
      component: AdjuntoComponent
  }
];

@NgModule({
  declarations: [
    AdjuntoComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FlexLayoutModule
  ]
})
export class AdjuntoModule { }
